import React from "react";
import logo from "./logo.svg";
import "./App.css";
import Navbar from "./components/Navbar";
import { BrowserRouter, Switch, Route } from "react-router-dom";
import Header from "./components/Header";
import Main from "./components/main";
import Create from "./components/Create";
import FirebaseState from "./firebase/firebaseState";
import Login from "./components/Login";
import EventState from "./event/EventState";
import Lesson from "./components/Lesson";
import LessonList from "./components/LessonList";
import Home from "./components/Home";
import CreateExercise from "./components/CreateExercise";
import ExerciseList from "./components/ExercisesList";
import Cookies from "./components/Cookies";

import Dostop from "./components/Dostop";
import StudentState from "./students/studentState";
import Students from "./students/Students";
import StudentItem from "./students/StudentItem";
import StudentInfo from "./students/StudentInfo";
import StudentTeacher from "./students/StudentTeacher";
import Register from "./students/Register";
import Pogoji from "./components/Pogoji";
import Ocenjevanje from "./components/Ocenjevanje";
import OcenaKerstein from "./components/OcenaKerstein";
import OcenaUrsic from "./components/OcenaUrsic";
import OcenaStanko from "./components/OcenaStanko";
import Upload from "./components/Upload";
import UploadKerstein from "./components/UploadKerstein";
import UploadFourB from "./components/UploadFourB";
import UploadFiveB from "./components/UploadFiveB";
import UploadSixB from "./components/UploadSixB";
import UploadSevenB from "./components/UploadSevenB";
import UploadEight from "./components/UploadEight";

function App() {
	return (
		<div>
			<BrowserRouter>
				<FirebaseState>
					<EventState>
						<StudentState>
							<Navbar />
							<Switch>
								<Route exact path='/' component={Home} />
								<Route exact path='/create' component={Create} />
								<Route
									exact
									path='/createExercise'
									component={CreateExercise}
								/>
								<Route exact path='/vaje' component={ExerciseList} />
								<Route exact path='/upload-4b' component={UploadFourB} />
								<Route exact path='/upload-5b' component={UploadFiveB} />
								<Route exact path='/upload-6b' component={UploadSixB} />
								<Route exact path='/upload-7b' component={UploadSevenB} />
								<Route exact path='/upload-89' component={UploadEight} />
								<Route exact path='/upload' component={Upload} />
								<Route exact path='/login' component={Login} />
								<Route exact path='/naloge' component={LessonList} />
								<Route exact path='/dostop' component={Dostop} />
								<Route exact path='/naloge/:lesson_id' component={Lesson} />
								<Route exact path='/cookies' component={Cookies} />
								<Route exact path='/ucenci' component={Students} />
								<Route exact path='/pogoji' component={Pogoji} />
								<Route exact path='/register' component={Register} />
								<Route exact path='/upload' component={Upload} />
								<Route exact path='/ucenec' component={StudentItem} />
								<Route exact path='/ocenjevanje' component={Ocenjevanje} />
								<Route
									exact
									path='/ocenjevanje-kerstein'
									component={OcenaKerstein}
								/>
								<Route
									exact
									path='/ocenjevanje-stanko'
									component={OcenaStanko}
								/>

								<Route exact path='/ocenjevanje-ursic' component={OcenaUrsic} />
								<Route
									exact
									path='/ucenec/:student_id'
									component={StudentInfo}
								/>
								<Route
									exact
									path='/ucenci/teacher/:student_id'
									component={StudentTeacher}
								/>
							</Switch>
						</StudentState>
					</EventState>
				</FirebaseState>
			</BrowserRouter>
		</div>
	);
}

export default App;
